import done_for_you from "./assets/done_for_you.png";
import fte from "./assets/fte.png";

import icon1 from "./assets/icon-1.png";
import icon2 from "./assets/icon-2.png";
import icon3 from "./assets/icon-3.png";
import icon4 from "./assets/icon-4.png";
import icon5 from "./assets/icon-5.png";
import icon6 from "./assets/icon-6.png";
import icon7 from "./assets/icon-7.png";
import icon8 from "./assets/icon-8.png";
import icon9 from "./assets/icon-9.png";
import icon10 from "./assets/icon-10.png";
import icon11 from "./assets/icon-11.png";
import icon12 from "./assets/icon-12.png";
import icon13 from "./assets/icon-13.png";
import icon14 from "./assets/icon-14.png";
import icon15 from "./assets/icon-15.png";
import icon16 from "./assets/icon-16.png";
import icon17 from "./assets/icon-17.png";

const getImagePath = (path) => `https://mirai-bay.com/configuratore${path}`;


const managersData = [
  {
    id: "benedetta",
    name: "Benedetta Premi",
    role: "Growth",
    color: "#0101ff",
    tag: [
      { image: icon1, role: "Growth Hacking" },
      { image: icon2, role: "Digital Advertising" },
      { image: icon3, role: "Performance Marketing" },
      { image: icon4, role: "Conversion Rate Optimization" },
      { image: icon5, role: "SEO & SEM" },
      { image: icon1, role: "Social Media Ads" },
      { image: icon2, role: "Funnel Marketing" },
      { image: icon3, role: "Customer Acquisition" },
      { image: icon4, role: "Conversion Rate Optimization" },
      { image: icon5, role: "Retention & Loyalty" },
    ],
    images: {
      default: getImagePath("/assets/Benedetta.png"),
      mobileSelected:{
        it: getImagePath("/assets/BenedettaMobileSelected.png"),
        en: getImagePath("/assets/BenedettaMobileSelectedEn.png"),
      },
      hover: getImagePath("/assets/hover_Benedetta.png"),
      card: {
        it:  getImagePath("/assets/card_Benedetta.png"),
        en: getImagePath("/assets/card_BenedettaEn.png"),
      },
      mobile: {
        it:  getImagePath("/assets/card_Benedetta.png"),
        en: getImagePath("/assets/card_BenedettaEn.png"),
      },
      active: {
        it: getImagePath("/assets/active_Benedetta.png"),
        en: getImagePath("/assets/active_Benedetta_en.png"),
      },
    },
    questions: [
      { id: 1, it: "Conoscere il mercato", en: "Understand the market" },
      { id: 2, it: "Aumentare le vendite online oppure i lead", en: "Increase online sales or lead generation" },
      { id: 3, it: "Comunicare il brand e accrescere notorietà", en: "Communicate the brand and increase awareness" },
      { id: 4, it: "Validazione e go-to-market", en: "Validation and go-to-market" }
    ]
  },
  {
    id: "giulia",
    name: "Giulia Cavallini",
    role: "Studio Executive Director",
    color: "#771ed6",
    tag: [
      { image: icon6, role: "Brand Identity" },
      { image: icon7, role: "Content Creation" },
      { image: icon8, role: "Graphic Design" },
      { image: icon9, role: "Video Production" },
      { image: icon6, role: "Storytelling" },
      { image: icon7, role: "Social Media Management" },
      { image: icon8, role: "Copywriting" },
      { image: icon9, role: "Creative Direction" },
      { image: icon9, role: "Visual Strategy" },
    ],
    images: {
      default: getImagePath("/assets/Giulia.png"),
      mobileSelected:{
        it: getImagePath("/assets/giuliaMobileSelected.png"),
        en: getImagePath("/assets/GiuliaMobileSelectedEn.png"),
      },
      hover: getImagePath("/assets/hover_Giulia.png"),
      card: {
        it: getImagePath("/assets/card_Giulia.png"),
        en: getImagePath("/assets/card_GiuliaEn.png"),
      },
      mobile: {
        it: getImagePath("/assets/card_Giulia.png"),
        en: getImagePath("/assets/card_GiuliaEn.png"),
      },
      active: {
        it: getImagePath("/assets/active_Giulia.png"),
        en: getImagePath("/assets/active_Giulia_en.png"),
      },
    },
    questions: [
      { id: 41, it: "Definire l'immagine del brand", en: "Define the brand image" },
      { id: 42 ,it: "Sviluppo di nuovi contenuti creativi", en: "Develop new creative content" }
    ]
  },
  {
    id: "francesco",
    name: "Francesco Ioppolo",
    role: "Tech",
    color: "#00d8ae",
    tag: [
      { image: icon10  , role: "Sviluppo Software" },
      { image: icon11  , role: "Web Development" },
      { image: icon12  , role: "App Development" },
      { image: icon13   , role: "UX/UI Design" },
      { image: icon10  , role: "Data Analytics" },
      { image: icon11  , role: "Artificial Intelligence" },
      { image: icon12  , role: "Automation" },
      { image: icon13   , role: "API Integration" },
      { image: icon12  , role: "Cybersecurity"},
      { image: icon13   , role: "Cloud Computing" },
    ],
    images: {
      default: getImagePath("/assets/Francesco.png"),
      mobileSelected:{
        it: getImagePath("/assets/FrancescoMobileSelected.png"),
        en: getImagePath("/assets/FrancescoMobileSelectedEn.png"),
      },
      hover: getImagePath("/assets/hover_Francesco.png"),
      card: {
        it: getImagePath("/assets/card_Francesco.png"),
        en: getImagePath("/assets/card_FrancescoEn.png"),
      },
      mobile: {
        it: getImagePath("/assets/card_Francesco.png"),
        en: getImagePath("/assets/card_FrancescoEn.png"),
      },
      active: {
        it: getImagePath("/assets/active_Francesco.png"),
        en: getImagePath("/assets/active_Francesco_en.png"),
      },
    },
    questions: [
      { id: 21, it: "Creare l'infrastruttura digitale", en: "Create the digital infrastructure" },
      { id: 22 ,it: "Ottimizzare l'infrastruttura digitale", en: "Optimize the digital infrastructure" }
    ]
  },
  {
    id: "davide",
    name: "Davide Crapanzano",
    role: "Accademy",
    color: "#ff00b7",
    tag: [
      { image: icon14   , role: "Formazione Aziendale" },
      { image: icon15   , role: "Corporate Training" },
      { image: icon16   , role: "Digital Learning" },
      { image: icon17   , role: "Soft Skills" },
      { image: icon14   , role: "Upskilling & Reskilling" },
      { image: icon15   , role: "Leadership Development" },
      { image: icon16   , role: "Team Coaching" },
      { image: icon17   , role: "Sales Training" },
      { image: icon17   , role: "Comunicazione Efficace" },
    ],
    images: {
      default: getImagePath("/assets/Davide.png"),
      mobileSelected:{
        it: getImagePath("/assets/DavideMobileSelected.png"),
        en: getImagePath("/assets/DavideMobileSelectedEn.png"),
      },
      hover: getImagePath("/assets/hover_Davide.png"),
      active: {
        it: getImagePath("/assets/active_Davide.png"),
        en: getImagePath("/assets/active_Davide_en.png"),
      },
      card: {
        it: getImagePath("/assets/card_Davide.png"),
        en: getImagePath("/assets/card_DavideEn.png"),
      },
      mobile: {
        it: getImagePath("/assets/card_Davide.png"),
        en: getImagePath("/assets/card_DavideEn.png"),
      },
    },
    questions: [
      { id: 31, it: "Elevare le competenze interne", en: "Elevate internal skills" },
      { id: 32 ,it: "Internalizzare il team di marketing", en: "Internalize the marketing team" }
    ]
  }
];


const workModes = [
  {
    id: "consulenza",
    title: {
      it: "Consulenza",
      en: "Consulting"
    },
    icon: getImagePath("/assets/consulenza.png"),
    description: {
      it: "Forniamo supporto strategico su misura per guidarti nel raggiungimento degli obiettivi di crescita.",
      en: "We provide tailored strategic support to guide you in achieving your growth goals."
    }
  },
  {
    id: "done_for_you",
    title: {
      it: "Done for you",
      en: "Done for you"
    },
    icon: done_for_you,
    description: {
      it: "Gestiamo in maniera completa tutte le attività necessarie per raggiungere i tuoi obiettivi.",
      en: "We fully manage all the necessary activities to achieve your goals."
    }
  },
  {
    id: "fte",
    title: {
      it: "FTE",
      en: "FTE"
    },
    icon: fte,
    description: {
      it: "Ti assegniamo, in maniera esclusiva, un esperto dedicato alle tue esigenze, sia in sede che da remoto.",
      en: "We assign you an expert dedicated to your needs, either on-site or remotely."
    }
  }
];


export { workModes, managersData }
